var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kf-image"},[_c('img',{class:{'is-rounded': _vm.rounded},attrs:{"alt":_vm.alt,"src":_vm.src}}),(_vm.caption)?_c('p',{staticClass:"kf-image-caption"},[_vm._v(" "+_vm._s(_vm.caption)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }